import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useConnection } from 'wagmi';

export const useSentryUser = () => {
  const { address, chain, connector } = useConnection();

  useEffect(() => {
    if (address && connector && chain) {
      Sentry.setUser({
        id: address,
        username: `${address.slice(0, 6)}...${address.slice(-4)}`,
      });

      Sentry.setTag('wallet_status', 'connected');
      Sentry.setTag('wallet_type', connector?.name || 'unknown');
      Sentry.setTag('chain_id', chain?.id ? String(chain.id) : 'unknown');

      Sentry.setContext('wallet', {
        address,
        connector: connector?.name || 'unknown',
      });

      Sentry.setContext('chain', {
        chainId: chain.id,
        network: chain.name,
      });
    } else {
      Sentry.setUser(null);
      Sentry.setTag('wallet_status', 'disconnected');
      Sentry.setContext('wallet', null);
      Sentry.setContext('chain', null);
    }
  }, [address, connector, chain]);
};
